import { Component, EventEmitter, OnInit } from '@angular/core';
import { CatUsuarios, EnviarCorreo, RegistroBitacoraInput } from 'app/entidades/entidades';
import { async } from '@angular/core/testing';
import { EnviarCorreoService } from '../../servicios/enviar-correo.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CatUsuariosService } from '../../servicios/cat-usuarios.service';
import { MuestraMensaje } from '../../shared/utilerias/notificaciones/notificaciones.component';
import { RegistroBitacoraService } from '../../servicios/registro-bitacora.service';
import { debug } from 'console';


declare var $: any;
@Component({
  selector: 'app-olvidopass',
  templateUrl: './olvidopass.component.html',
  styleUrls: ['./olvidopass.component.css']
})
export class OlvidopassComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  enviarCorreoForm: FormGroup;
  mensajeForm: FormGroup;
  public datosenviarCorreo$ = new EventEmitter<EnviarCorreo>();
  contrasenia: string;
  enviaC: boolean = false;
  public colorC: boolean ;
  public email_: string;
  public registroBitacora = new RegistroBitacoraInput();



  handleChange(e) {
    this.enviaC = e.checked;
  }
  constructor(
    private formBuilder: FormBuilder,
    private registroBitacoraService: RegistroBitacoraService,

     private enviarCorreoService: EnviarCorreoService,
     private catUsuariosService: CatUsuariosService,
     ) { }

  ngOnInit(): void {
    this.enviarCorreoForm = this.formBuilder.group({
      correo : [undefined],
      usuario: [undefined]
      
    });
    this.mensajeForm = this.formBuilder.group({
      mensaje_: [undefined],
    });
    
  }




   // ====================================================
  // child enviar-correo 
  // ====================================================
  // El envio de la contraseña se debe de mandar desde el backend, no desde el front. (MAHERO). Motivo por el cual se comenta el siguiente código.
  async enviarCorreo() {
    // try {
       
    //   if (this.email_ == null)
    //   throw new Error ("El usuario no tiene un Correo electronico registrado");

    //   let datosenviarCorreo = new EnviarCorreo();
    //   // datosenviarCorreo = this.enviarCorreoForm.value;
    //   datosenviarCorreo.contrasenia = this.contrasenia;
    //   datosenviarCorreo.enviosFactura = false;
    //   datosenviarCorreo.correo = this.email_;
    //   const datoretorno = await this.enviarCorreoService.add(datosenviarCorreo).toPromise();
    //   let respuesta = datoretorno;
    //  if (respuesta.toString()== "OK") {
    //     this.mensajeForm.patchValue({
    //         mensaje_: "Se envío éxitosamente el correo"
    //     });
    //     this.colorC = false;
    //  }else {
    //   this.mensajeForm.patchValue({
    //     mensaje_: respuesta
    //   });
    //   this.colorC = true;
    //  }
    // } catch (e) {
    //   if (e.response) throw { message: e.response.data };
    //   else throw e;
    // } finally {
    // }
  }

  cadenaAleatoria(longitud, caracteres) {
    longitud = longitud || 16;
    caracteres = caracteres || "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var cadena = "";
    var max = caracteres.length-1;
    for (var i = 0; i<longitud; i++) {
        cadena += caracteres[ Math.floor(Math.random() * (max+1)) ];
    }
  let cadenaCaracteresEspeciales="@#$%^&+=";
   
       for (var i = 0; i<2; i++) {
        cadena += cadenaCaracteresEspeciales[ Math.floor(Math.random() * (9)) ];
    }
  

    let subCadena=cadena.substring(0,9)+Math.floor(Math.random() * 10);
   this.contrasenia = subCadena;
}
async cambioContrasenya() {  // Este procedimiento es incorrecto, no se debe de cambiar la contraseña desde el front, se debe de hacer desde el backend. (MAHERO)
  try {

    // await this.cadenaAleatoria(10,'0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
    // let catUsuarios = new CatUsuarios();
    // catUsuarios.contrasenia =   this.contrasenia;
    // catUsuarios.fechaBaja = new Date(Date.now());
    // catUsuarios.fechaAlta = new Date(Date.now());
    // catUsuarios.idEstatus = 1;
    // catUsuarios.nombreUsuario = this.enviarCorreoForm.value.usuario;
    // const datoRetorno = await this.catUsuariosService.actualiza(catUsuarios).toPromise();
    // console.log('?------------>',datoRetorno);
    // debugger;
    // if (datoRetorno.id === 0 || !datoRetorno.id)
    //   throw new Error ("El usuario es incorrecto o No existe");
    // this.email_ = datoRetorno.correoElectronico;
    // await this.enviarCorreo();
    // this.registroBitacora.idUsuario = datoRetorno.id;
    // this.registroBitacora.accion = "SE MANDO CORREO CON CONTRASEÑA";
    // const datRetorno = await this.registroBitacoraService.add(this.registroBitacora).toPromise();

  }catch (e) {
    debugger;

     this.muestraMensaje.error(e.message, "top", "center");
  } finally {

  }
}
}
 